$(function(){
  // ファーストビューで見えているチャートはスクロールしなくても発火
  renderkuchikomiDoughnutChart(this);

  // ファーストビューで隠れているチャートはスクロールで発火
  $(window).scroll(function () {
    renderkuchikomiDoughnutChart(this);
  });

  function renderkuchikomiDoughnutChart(target) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    $('.js-kuchikomi__donuts-graph:not(.rendered)').each(function(){
      var elemTop = $(this).offset().top;
      var targetCanvas = $(this);
      if(elemTop < docViewBottom) {
        var kuchikomiDoughnutChart = targetCanvas[0];
        if (kuchikomiDoughnutChart) {
          $(kuchikomiDoughnutChart).addClass('rendered');
          var ctxKuchikomiDoughnut = kuchikomiDoughnutChart.getContext("2d");
          var kuchikomiDoughnutChart = new Chart(ctxKuchikomiDoughnut, {
            type: 'doughnut',
            data: {
              labels: [
                '☆1',
                '☆2',
                '☆3',
                '☆4',
                '☆5'
              ],
              datasets: [{
                data: JSON.parse(kuchikomiDoughnutChart.getAttribute('data-scores')),
                backgroundColor: [
                  "#4098d5",
                  "#5cceaa",
                  "#c5da4e",
                  "#fdd10c",
                  "#f89665"
                ],
                borderWidth: 0
              }]
            },
            options:{
              responsive: false,
              legend: {
                display: false
              },
              animation: false
            }
          });
        }
      }
    });
  }

});
